<template>
    <b-container>
        <h2>{{ msg }}</h2>
        <hr size=1>
        <b-container>
          <h3><a href="https://fontawesome.com/icons?d=gallery&m=free" target="_blank">Font Awesome</a></h3>
        <b-row>
          <b-col>
            <font-awesome-icon icon="user-secret" />
          </b-col>
          <b-col>
            <font-awesome-icon icon="key" />
          </b-col>
          <b-col>
            <font-awesome-icon icon="mask" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <font-awesome-icon icon="cat" />
          </b-col>
          <b-col>
            <font-awesome-icon icon="angry" />
          </b-col>
          <b-col>
            <font-awesome-icon icon="bell" />
          </b-col>
        </b-row>
        </b-container>
        <hr size=1>
        <b-container>
          <h3><a href="https://bootstrap-vue.js.org/docs/icons/" target="_blank">BootStrap Vue Icons</a></h3>
        <b-row>
          <b-col>
            <b-icon-alarm></b-icon-alarm>
          </b-col>
          <b-col>
            <b-icon-cloud></b-icon-cloud>
          </b-col>
          <b-col>
            <b-icon-alert-circle-fill class="h1 mb-2"></b-icon-alert-circle-fill>
            <b-icon-alert-circle-fill class="h2 mb-2"></b-icon-alert-circle-fill>
            <b-icon-alert-circle-fill class="h3 mb-2"></b-icon-alert-circle-fill>
            <b-icon-alert-circle-fill class="h4 mb-2"></b-icon-alert-circle-fill>
            <b-icon-alert-circle-fill class="h5 mb-2"></b-icon-alert-circle-fill>
            <b-icon-alert-circle-fill class="h6 mb-2"></b-icon-alert-circle-fill>
            <b-icon-alert-circle-fill class="h7 mb-2"></b-icon-alert-circle-fill>
          </b-col>
          <b-col>
            <b-icon-camera font-scale=".5"></b-icon-camera>
            <b-icon-camera font-scale="1"></b-icon-camera>
            <b-icon-camera font-scale="2"></b-icon-camera>
            <b-icon-camera font-scale="3"></b-icon-camera>
            <b-icon-camera font-scale="4"></b-icon-camera>
            <b-icon-camera font-scale="5"></b-icon-camera>
            <b-icon-camera font-scale="6"></b-icon-camera>
            <b-icon-camera font-scale="7"></b-icon-camera>
          </b-col>
        </b-row>
        </b-container>

    </b-container>
</template>

<script>
/* eslint-disable */

var data = {
  msg: 'Font Awesome/Icons Test Page'
}

export default {
  name: 'FontAwesome',
  data () { return data }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/FontAwesome.vue